var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown-item',{attrs:{"aria-role":"listitem"},on:{"click":_vm.listenLoad}},[_c('headphones-icon',{staticClass:"dropdown-item-icon",attrs:{"size":"1.5x"}}),_vm._v(" "+_vm._s(_vm.$t('dict.listenOrRead'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }